import { render, staticRenderFns } from "./banks_add.vue?vue&type=template&id=39b13478&scoped=true"
import script from "./banks_add.vue?vue&type=script&lang=js"
export * from "./banks_add.vue?vue&type=script&lang=js"
import style0 from "./banks_add.vue?vue&type=style&index=0&id=39b13478&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b13478",
  null
  
)

export default component.exports